import { Getagentlist } from '@/api/client'
import { ConfirmInput, DeleteModal, IconFont, SignTitle } from '@/components'
import { useRequest, useSelections } from 'ahooks'
import {
  Row,
  Col,
  Typography,
  Dropdown,
  Menu,
  Switch,
  Form,
  Select,
  Empty,
  Breadcrumb,
  Modal,
  Input,
  Button,
  Checkbox,
} from 'antd'
import { useEffect, useMemo, useState, useCallback } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Scrollbar from 'react-custom-scrollbars'
import { FixedSizeList as List } from 'react-window'
import { t } from '@/i18n'
import {
  useBatchDeleteClient,
  useBatchUnloadClient,
  useClientRemark,
  useDeleteClient,
  useGetagentarea,
  useGetagentlist,
  usePutoperate,
  useUninstallClient,
  useUpdateAlias,
  useUpdatearea,
  useLogsCollectStart,
  useLogsCollectStop,
} from '../util'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import { LogDownload } from './log-download'
import { Message } from '@/components/message'
import { ShowClientHash } from '..'
import ReactECharts from 'echarts-for-react'
import EnvManagement from './env-management'

/**
 * 虚拟列表优化说明：
 * 1. 使用 react-window 的 FixedSizeList 实现虚拟滚动
 * 2. 只渲染可见区域的项目，大幅提升大数据量下的性能
 * 3. 每个客户端项高度固定为 140px，可根据实际需要调整
 * 4. 支持动态计算列表高度，适配不同屏幕尺寸
 * 5. 保持原有的所有功能，包括选择、编辑、操作等
 */

const { useForm } = Form

interface EditRemarks {
  visibel: boolean
  id?: string
  alias?: 'name' | 'remark' | 'bandwidth_upstream' | 'bandwidth_downstream'
}
export const ClientList = () => {
  const [showClientHash, setShowClientHash] = useState<ShowClientHash>({
    visible: false,
    clientName: '',
  })
  const [getAgent, setGetAgent] = useState<Getagentlist>({ search: '' })
  const [getAgentList, clientList, clientLoad] = useGetagentlist({ GetagentParams: getAgent })
  const [editRemark, setEditRemark] = useState<EditRemarks>({ visibel: false })
  const [deleteClient] = useDeleteClient()
  const [uninstallClient] = useUninstallClient()
  const [updateAlias] = useUpdateAlias()
  const [putOperate] = usePutoperate()
  const [getAgentArea] = useGetagentarea()
  const [updateArea] = useUpdatearea()
  const [logsCollectStart] = useLogsCollectStart()
  const [logsCollectStop] = useLogsCollectStop()
  const [showLog, setShowLog] = useState({ visible: false, id: null })
  const [form] = useForm()
  const [searchForm] = useForm()
  let [switchItem, setSwitchItem] = useState<{
    id: string | null
    auto: boolean | null
    remark: string
    areaId: number | null
    bizId: number | null
  }>({
    id: null,
    auto: null,
    remark: '',
    areaId: null,
    bizId: null,
  })
  const [clientRemark, clientLoading] = useClientRemark()
  const [batchDeleteClient] = useBatchDeleteClient()
  const [batchUnloadClient] = useBatchUnloadClient()
  const [autoUpgrade, setAutoUpgrade] = useState<{
    visible: boolean
    id: string | null
    remark: string | null
    areaId: number | null
    bizId: number | null
  }>({
    visible: false,
    id: null,
    remark: null,
    areaId: null,
    bizId: null,
  })
  const [deleteMode, setDeleteMode] = useState<{
    visible: boolean
    id: string | null
  }>({
    visible: false,
    id: null,
  })
  const [uninstallMode, setUninstallMode] = useState<{
    visible: boolean
    id: number | null
  }>({
    visible: false,
    id: null,
  })
  const [agentareaList, setAgentareaList] = useState<{ id: string; name: string }[]>([])
  const [showStorage, setShowStorage] = useState({ visible: false, id: '' })
  const [showBatch, setShowBatch] = useState({ visible: false, type: '' })
  const [showEnvManagement, setShowEnvManagement] = useState<{
    visible: boolean
    id: string
    clientStatus: number
  }>({ visible: false, id: '', clientStatus: 0 })

  // 虚拟列表相关状态
  const [listHeight, setListHeight] = useState(800)
  const itemHeight = 140 // 每个客户端项的高度

  // 计算列表高度
  useEffect(() => {
    const container = document.querySelector('.client-list-container')
    if (container) {
      const containerHeight = container.clientHeight
      setListHeight(containerHeight) // 减去头部和其他元素的高度
    }
  }, [])

  const option = useMemo(
    () => () => ({
      tooltip: {
        trigger: 'item',
      },
      legend: {
        orient: 'vertical',
        right: 'right',
        bottom: 'center',
      },
      color: ['#163172', '#2090A8'],
      series: [
        {
          name: t('内存使用'),
          type: 'pie',
          radius: '50%',
          left: '-25%',
          showEmptyCircle: true,
          data: [
            {
              value: (
                clientList.find(client => client.id === showStorage.id)?.memory_usage?.used /
                1024 /
                1024 /
                1024
              ).toFixed(2),
              name: t('已用'),
            },
            {
              value: (
                (clientList.find(client => client.id === showStorage.id)?.memory_usage?.total -
                  clientList.find(client => client.id === showStorage.id)?.memory_usage?.used) /
                1024 /
                1024 /
                1024
              ).toFixed(2),
              name: t('剩余'),
            },
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    }),
    [showStorage.visible],
  )

  const diskOption = useMemo(
    () => value => ({
      tooltip: {
        trigger: 'item',
      },
      legend: {
        orient: 'vertical',
        right: 'right',
        bottom: 'center',
      },
      color: ['#163172', '#2090A8'],
      series: [
        {
          name: t('磁盘使用'),
          type: 'pie',
          radius: '50%',
          left: '-25%',
          showEmptyCircle: true,
          data: [
            {
              value: (value?.used / 1024 / 1024 / 1024).toFixed(2),
              name: t('已用'),
            },
            {
              value: ((value?.total - value?.used) / 1024 / 1024 / 1024).toFixed(2),
              name: t('剩余'),
            },
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    }),
    [showStorage.visible],
  )
  const selectDeleteId = useMemo(
    () =>
      (clientList.length > 0 &&
        clientList.map(v => v.conn_status === 2 && v.id).filter(item => item)) ||
      [],
    [clientList],
  )
  const { selected, isSelected, unSelect, toggle } = useSelections(selectDeleteId || [])
  const selectUnloadId = useMemo(
    () =>
      (clientList.length > 0 &&
        clientList.map(v => v.conn_status === 1 && v.id).filter(item => item)) ||
      [],
    [clientList],
  )
  const {
    selected: selectedUnload,
    isSelected: isSelectedUnload,
    toggle: toggleUnload,
    unSelect: unSelectUnload,
  } = useSelections(selectUnloadId)
  useEffect(() => {
    getAgentArea({ search: '' })
      .then(res => {
        if (JSON.stringify(res.data) !== '{}') {
          setAgentareaList(res.data.area_list)
        }
      })
      .catch(() => {})
  }, [])
  useEffect(() => {
    if (switchItem.id) {
      clientRemark({
        id: Number(switchItem.id),
        remark: switchItem.remark,
        auto: switchItem?.auto ? 1 : 2,
        change_area_id: Number(switchItem.id),
        biz_id: switchItem.bizId || '',
        area_id: switchItem.areaId || '',
      })
        .then(() => {
          getAgentList().catch(_ => {})
        })
        .catch(_ => {})
    }
  }, [switchItem])
  useEffect(() => {
    clientList.forEach(client => {
      try {
        let hashArr
        hashArr = client?.hashs.map((item, index) => {
          const hash = {
            id: index,
            ...item,
            ...item.hashs,
            file_type: item.type,
          }
          delete hash.hashs
          return hash
        })
      } catch (error) {}
    })
  }, [switchItem.id])
  useEffect(() => {
    if (showStorage.visible) {
    }
  }, [showStorage.visible])
  const Remark = values => {
    const {
      id,
      name,
      onOk,
      alias,
      onCancel,
      upAlias,
      type = 'input',
      min = null,
      max = null,
      placeholder,
    } = values
    if (editRemark.id === id && editRemark.alias === alias) {
      return (
        <ConfirmInput
          placeholder={placeholder}
          name={alias === 'name' ? upAlias : name}
          title={alias === 'name' ? '' : name}
          id={id}
          onOk={onOk}
          onCancel={onCancel}
          type={type}
          min={min}
          max={max}
          unit="M"
          style={{ marginRight: '5px' }}
        />
      )
    } else {
      return (
        <Typography.Text
          style={{
            fontSize: '14px',
            fontWeight: 400,
            flex: 1,
          }}
          className={alias === 'name' && !upAlias ? 'breathe' : ''}
          ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
        >
          {alias === 'name'
            ? `${upAlias || t('未命名')}(${name})`
            : !name
            ? ''
            : alias === 'bandwidth_upstream' || alias === 'bandwidth_downstream'
            ? `${name}M`
            : name}
        </Typography.Text>
      )
    }
  }
  const { run: status } = useRequest(
    (value): any => {
      setGetAgent(origin => ({ ...origin, conn_status: value }))
    },
    {
      debounceWait: 300,
      manual: true,
    },
  )
  const { run: search } = useRequest(
    (value): any => {
      setGetAgent(origin => ({ ...origin, search: value }))
    },
    {
      debounceWait: 300,
      manual: true,
    },
  )
  const updateClient = () => {
    getAgentList().catch(() => {})
  }

  // 虚拟列表渲染组件
  const VirtualClientItem = useCallback(
    ({ index, style }: { index: number; style: React.CSSProperties }) => {
      const client = clientList[index]
      if (!client) return null

      return (
        <div style={style}>
          <Form
            form={form}
            key={client.id}
            initialValues={{ [`select${index}`]: 0 }}
            style={{ width: 'calc(100%)' }}
          >
            <ListItem key={client.id} align={'middle'} justify={'space-around'}>
              <Col
                className="col"
                span={1}
                style={{ flexDirection: 'column', alignItems: 'center' }}
              >
                <Checkbox
                  checked={
                    client.conn_status === 1 ? isSelectedUnload(client.id) : isSelected(client.id)
                  }
                  onChange={() => {
                    if (client.conn_status === 1) {
                      toggleUnload(client.id)
                    } else {
                      toggle(client.id)
                    }
                  }}
                />
              </Col>
              <Col className="col" span={4} style={{ flexDirection: 'column' }}>
                <div style={{ width: '100%' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '30px',
                    }}
                  >
                    {client.conn_status === 1 && <div className="succeed" />}
                    {client.conn_status === 2 && <div className="error" />}
                    {client?.os_architecture === 'X86' ? (
                      <div
                        style={{
                          width: '32px',
                          height: '18px',
                          background: '#D2E9EE',
                          borderRadius: '4px',
                          lineHeight: '18px',
                          textAlign: 'center',
                          fontWeight: 400,
                          fontSize: '12px',
                          color: '#2090A8',
                          marginRight: '4px',
                        }}
                      >
                        X86
                      </div>
                    ) : (
                      <div
                        style={{
                          width: '32px',
                          height: '18px',
                          background: '#DCDBF0',
                          borderRadius: '4px',
                          lineHeight: '18px',
                          textAlign: 'center',
                          fontWeight: 400,
                          fontSize: '12px',
                          color: '#4C45B5',
                          marginRight: '4px',
                        }}
                      >
                        ARM
                      </div>
                    )}
                    <Remark
                      name={`${client.hostname}`}
                      style={{ width: '150px' }}
                      id={client.id}
                      placeholder={t('输入名称')}
                      upAlias={client.alias}
                      onOk={(newName: string) => {
                        if (newName.length > 15) {
                          Message.error(t('客户端别名最多15字'))
                          return
                        }
                        updateAlias({ id: client.id, alias: newName })
                          .then(() => {
                            getAgentList().catch(_ => {})
                            setEditRemark({ visibel: false })
                          })
                          .catch(_ => {})
                      }}
                      alias={'name'}
                      onCancel={() => {
                        setEditRemark({ visibel: false })
                      }}
                    />
                    {!(editRemark.alias === 'name' && editRemark.id === client.id) && (
                      <IconFont
                        type="icon-huabanfuben"
                        onClick={() => {
                          setEditRemark({
                            visibel: true,
                            id: client.id,
                            alias: 'name',
                          })
                        }}
                        style={{ color: '#999', cursor: 'pointer', marginLeft: 8 }}
                      />
                    )}
                  </div>
                  <div
                    style={{
                      fontSize: '12px',
                      width: '100%',
                      height: '30px',
                      lineHeight: '30px',
                    }}
                    className="text"
                  >
                    <span className="title">{t('最后在线时间：')}</span>
                    {client.online_time}
                  </div>
                </div>
              </Col>
              <Col span={4} className="col" style={{ flexDirection: 'column' }}>
                <div style={{ marginBottom: 30 }}>
                  <span>{t('安全域：')}</span>
                  <Select
                    value={client.area_id}
                    defaultValue={t('默认安全域')}
                    style={{ width: '160px', height: '30px' }}
                    onChange={value =>
                      updateArea({ id: client.id, area_id: value })
                        .then(res => {
                          console.log(res)
                          Message.success(t('修改成功'))
                          getAgentList()
                        })
                        .catch(() => {})
                    }
                  >
                    {agentareaList.map((item: any) => (
                      <Select.Option name={item.name} value={item.id} key={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
                {client.verification_type !== 2 && (
                  <div
                    style={{
                      fontSize: '13px',
                      height: '30px',
                    }}
                  >
                    <span style={{ display: 'inline-block', width: 60 }} className="title">
                      {t('自动升级')}
                    </span>
                    <Switch
                      size={'small'}
                      defaultChecked={client.upgrade === 1}
                      checked={client.upgrade === 1}
                      loading={clientLoad || clientLoading}
                      onChange={e => {
                        if (!e) {
                          setAutoUpgrade({
                            visible: true,
                            id: client.id,
                            remark: client.remark ? client.remark : '',
                            areaId: client.area_id || 0,
                            bizId: client?.biz_id || 0,
                          })
                          return
                        }
                        setSwitchItem({
                          auto: e,
                          id: client.id,
                          remark: client.remark ? client.remark : '',
                          areaId: client.area_id || 0,
                          bizId: client?.biz_id || 0,
                        })
                      }}
                    />
                  </div>
                )}
              </Col>
              <Col span={1.5} style={{ flexDirection: 'column' }} className="col">
                <div
                  style={{
                    height: '30px',
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center',
                    marginBottom: '25px',
                  }}
                >
                  <Typography.Link
                    className="storage-space"
                    onClick={() => setShowStorage({ visible: true, id: client.id })}
                  >
                    <span className="hash">{t('客户端详情')}</span>
                  </Typography.Link>
                </div>
                <div style={{ marginBottom: '8px' }}>
                  <Typography.Link
                    onClick={() => {
                      let hashArr = []
                      try {
                        hashArr = client?.hashs.map((item, i) => {
                          const hash = {
                            id: i,
                            ...item,
                            ...item.hashs,
                            file_type: item.type,
                          }
                          delete hash.hashs
                          return hash
                        })
                      } catch (error) {}
                      setShowClientHash({
                        visible: true,
                        clientName: `${client.alias || t('未命名')}(${client.hostname})`,
                        hashArr,
                      })
                    }}
                  >
                    <span className="hash">{t('客户端哈希值')}</span>
                  </Typography.Link>
                </div>
              </Col>
              <Col span={2} style={{ flexDirection: 'column' }} className="col" />
              {client.verification_type !== 2 ? (
                <Col span={4} style={{ flexDirection: 'column' }} className="col">
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                      marginBottom: '18px',
                    }}
                  >
                    <div className="title">{t('带宽上行：')}</div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Remark
                        id={client?.id}
                        name={client.bandwidth_upstream}
                        alias={'bandwidth_upstream'}
                        type="inputNumber"
                        placeholder="1-10000"
                        min={1}
                        max={10000}
                        onOk={async value => {
                          try {
                            if (value > 10000 || value < 0) {
                              Message.error('')
                              return
                            }
                            await putOperate({
                              id: client.id,
                              auto: client.upgrade,
                              remark: client.remark,
                              bandwidth_upstream: value,
                              biz_id: client?.bizId || 0,
                              area_id: client.areaId || 0,
                              change_area_id: client.id,
                            })
                            await getAgentList()
                            setEditRemark({ visibel: false })
                          } catch (err) {}
                        }}
                        onCancel={() => {
                          setEditRemark({ visibel: false })
                        }}
                      />
                    </div>
                    {!(
                      editRemark.alias === 'bandwidth_upstream' && editRemark.id === client.id
                    ) && (
                      <IconFont
                        type="icon-huabanfuben"
                        style={{
                          color: '#999',
                          cursor: 'pointer',
                          marginLeft: 5,
                          marginRight: 5,
                        }}
                        onClick={() => {
                          setEditRemark({
                            visibel: true,
                            id: client.id,
                            alias: 'bandwidth_upstream',
                          })
                        }}
                      />
                    )}
                  </div>
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                    }}
                  >
                    <div className="title">{t('带宽下行：')}</div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Remark
                        id={client?.id}
                        name={client.bandwidth_downstream}
                        alias={'bandwidth_downstream'}
                        type="inputNumber"
                        placeholder="1-10000"
                        min={1}
                        max={10000}
                        onOk={async value => {
                          try {
                            if (value > 10000) {
                              Message.error('')
                              return
                            }
                            await putOperate({
                              id: client.id,
                              auto: client.upgrade,
                              remark: client.remark,
                              bandwidth_downstream: value,
                              biz_id: client?.bizId || 0,
                              area_id: client.areaId || 0,
                              change_area_id: client.id,
                            })
                            await getAgentList()
                            setEditRemark({ visibel: false })
                          } catch (err) {}
                        }}
                        onCancel={() => {
                          setEditRemark({ visibel: false })
                        }}
                      />
                    </div>
                    {!(
                      editRemark.alias === 'bandwidth_downstream' && editRemark.id === client.id
                    ) && (
                      <IconFont
                        type="icon-huabanfuben"
                        style={{
                          color: '#999',
                          cursor: 'pointer',
                          marginLeft: 5,
                          marginRight: 5,
                        }}
                        onClick={() => {
                          setEditRemark({
                            visibel: true,
                            id: client.id,
                            alias: 'bandwidth_downstream',
                          })
                        }}
                      />
                    )}
                  </div>
                </Col>
              ) : (
                <Col span={4} style={{ flexDirection: 'column' }} className="col" />
              )}
              <Col span={3} style={{ flexDirection: 'column' }} className="col">
                <div
                  style={{
                    height: '30px',
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center',
                    marginBottom: '18px',
                  }}
                >
                  <Typography.Link
                    disabled={client.conn_status === 1 ? false : true}
                    onClick={() => {
                      if (client.status !== 1) {
                        logsCollectStart({ agent_id: client.id })
                          .then(() => {
                            getAgentList().catch(() => {})
                          })
                          .catch(() => {})
                      }
                      if (client.status === 1) {
                        logsCollectStop({ agent_id: client.id })
                          .then(() => {
                            getAgentList().catch(() => {})
                          })
                          .catch(() => {})
                      }
                    }}
                  >
                    <span className="hash">
                      {client.status === 1 ? t('停止') : t('开始')}
                      {t('收集运行日志')}
                    </span>
                  </Typography.Link>
                </div>
                <div style={{ height: '30px', display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <Typography.Link
                    className="storage-space"
                    onClick={() => setShowLog({ visible: true, id: client.id })}
                  >
                    <span className="hash">
                      <IconFont type="icon-xiazai2" style={{ marginRight: 5 }} />
                      {t('运行日志下载')}
                    </span>
                  </Typography.Link>
                </div>
              </Col>
              <Col span={4} style={{ flexDirection: 'column' }} className="col">
                <div
                  style={{
                    height: '30px',
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center',
                    marginBottom: '18px',
                    marginTop: client.auto_install_dependency_env === 'SwitchOn' ? '0' : '20px',
                  }}
                >
                  <div className="title" style={{ width: '30px' }}>
                    {t('备注')}
                  </div>
                  {!(editRemark.alias === 'remark' && editRemark.id === client.id) && (
                    <IconFont
                      type="icon-huabanfuben"
                      style={{
                        color: '#999',
                        cursor: 'pointer',
                        marginLeft: 5,
                        marginRight: 5,
                      }}
                      onClick={() => {
                        setEditRemark({
                          visibel: true,
                          id: client.id,
                          alias: 'remark',
                        })
                      }}
                    />
                  )}
                  <div style={{ width: '100px' }}>
                    <Remark
                      id={client?.id}
                      name={client.remark}
                      alias={'remark'}
                      placeholder={t('输入备注')}
                      onOk={async newName => {
                        try {
                          if (newName.length > 256) {
                            Message.error('')
                            return
                          }
                          await putOperate({
                            id: client.id,
                            auto: client.upgrade || 2,
                            remark: newName,
                            biz_id: client?.bizId || 0,
                            area_id: client.areaId || 0,
                            change_area_id: client.id,
                          })
                          await getAgentList()
                          setEditRemark({ visibel: false })
                        } catch (err) {}
                      }}
                      onCancel={() => {
                        setEditRemark({ visibel: false })
                      }}
                    />
                  </div>
                </div>
                {client.auto_install_dependency_env === 'SwitchOn' && (
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                    }}
                  >
                    <Button
                      disabled={client.conn_status === 1 ? false : true}
                      type="link"
                      style={{ padding: '6.6px 0' }}
                      onClick={() => {
                        setShowEnvManagement({
                          visible: true,
                          id: client.id,
                          clientStatus: client.conn_status,
                        })
                      }}
                    >
                      {t('验证环境管理')}
                    </Button>
                  </div>
                )}
              </Col>
              <Col className="col" style={{ alignItems: 'center' }}>
                <Dropdown
                  overlay={
                    <Menu>
                      <MenuItem
                        disabled={client.conn_status === 2 ? false : true}
                        key={4}
                        onClick={() => setDeleteMode({ visible: true, id: client.id })}
                      >
                        {t('删除')}
                      </MenuItem>
                      <MenuItem
                        disabled={client.conn_status === 1 ? false : true}
                        key={5}
                        onClick={() => setUninstallMode({ visible: true, id: client.id })}
                      >
                        {t('卸载')}
                      </MenuItem>
                    </Menu>
                  }
                  placement={'bottomLeft'}
                  trigger={['click']}
                  overlayStyle={{ minWidth: '120px' }}
                >
                  <IconFont type="icon-caozuo" style={{ color: '#4238C9', cursor: 'pointer' }} />
                </Dropdown>
              </Col>
            </ListItem>
          </Form>
        </div>
      )
    },
    [
      clientList,
      form,
      editRemark,
      agentareaList,
      clientLoad,
      clientLoading,
      showClientHash,
      showStorage,
      showLog,
      showEnvManagement,
      isSelected,
      isSelectedUnload,
      toggle,
      toggleUnload,
      updateAlias,
      getAgentList,
      setEditRemark,
      updateArea,
      setAutoUpgrade,
      setSwitchItem,
      setShowClientHash,
      setShowStorage,
      setShowLog,
      setShowEnvManagement,
      setDeleteMode,
      setUninstallMode,
      putOperate,
      logsCollectStart,
      logsCollectStop,
    ],
  )
  return (
    <div style={{ height: '100%', overflow: 'hidden', paddingBottom: 50, background: '#F1F3F5 ' }}>
      <Breadcrumb style={{ margin: '12px' }}>
        <Breadcrumb.Item>{t('配置中心')}</Breadcrumb.Item>
        <Breadcrumb.Item>{t('客户端管理')}</Breadcrumb.Item>
      </Breadcrumb>
      <div
        style={{
          padding: '20px',
          background: '#fff',
          height: '100%',
          margin: '0 12px',
          borderRadius: '8px',
          position: 'relative',
        }}
      >
        <div
          style={{
            fontSize: '16px',
            fontWeight: '500',
            color: '#333',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <span>{t('客户端列表')}</span>
          <Link to={'/configure/client/download'} target="_blank">
            <Button type="primary">{t('客户端下载')}</Button>
          </Link>
        </div>
        {(clientList?.length > 0 || getAgent.search !== '' || getAgent.conn_status) && (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form form={searchForm} style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <Form.Item name="keyword">
                <Input
                  prefix={<IconFont type="icon-sousuo1" style={{ color: '#666', fontSize: 16 }} />}
                  placeholder={t('主机名/别名/本机IP/host_id')}
                  onChange={e => {
                    search(e.target.value)
                  }}
                  style={{ width: 310, height: 32 }}
                />
              </Form.Item>
              <Form.Item name="status">
                <Select
                  allowClear
                  style={{ width: '315px', height: '32px' }}
                  onChange={e => {
                    status(e)
                  }}
                  placeholder={t('客户端状态')}
                >
                  <Select.Option value="1">{t('在线')}</Select.Option>
                  <Select.Option value="2">{t('离线')}</Select.Option>
                </Select>
              </Form.Item>
              <div
                style={{ color: '#4238C9', cursor: 'pointer', marginBottom: '28px' }}
                onClick={() => {
                  console.log(searchForm.getFieldValue('keyword'))

                  searchForm.setFieldsValue({ keyword: '' })
                  searchForm.setFieldsValue({ status: undefined })
                  setGetAgent({ search: '', conn_status: undefined })
                }}
              >
                {t('重置')}
              </div>
            </Form>
            <div>
              {selected.length > 0 && selectDeleteId.length > 0 && (
                <Button
                  type="primary"
                  style={{ marginLeft: '30px' }}
                  onClick={() => {
                    setShowBatch({ visible: true, type: 'delete' })
                  }}
                >
                  {t('批量删除')}
                </Button>
              )}
              {selectedUnload.length > 0 && selectUnloadId.length > 0 && (
                <Button
                  type="primary"
                  style={{ marginLeft: '30px' }}
                  onClick={() => {
                    setShowBatch({ visible: true, type: 'unload' })
                  }}
                >
                  {t('批量卸载')}
                </Button>
              )}
            </div>
          </div>
        )}
        <div
          style={{
            width: '100%',
            borderBottom: '1px dashed #d5d9dd',
            position: 'absolute',
            left: 0,
            top: '114px',
          }}
        />
        <Scrollbar style={{ height: '85%' }} className="client-list-container">
          {clientList?.length > 0 ? (
            <List
              height={listHeight}
              itemCount={clientList.length}
              itemSize={itemHeight}
              width="100%"
            >
              {VirtualClientItem}
            </List>
          ) : (
            <Empty
              image={EmptyImg}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
                flexWrap: 'wrap',
              }}
            />
          )}
        </Scrollbar>
        <StorageModal
          width={600}
          centered
          title={<SignTitle show>{t('客户端详情')}</SignTitle>}
          open={showStorage.visible}
          onCancel={() => setShowStorage({ visible: false, id: '' })}
          footer={null}
          destroyOnClose
        >
          {clientList.find(client => client.id === showStorage?.id) && (
            <div className="content">
              <div
                style={{
                  color: '#333333',
                  fontSize: '14px',
                  fontWeight: 600,
                  marginBottom: '20px',
                }}
              >
                {t('基础信息')}
              </div>
              <div className="ip-address">
                <span className="title" style={{ color: '#86909C' }}>
                  {t('主机名称：')}
                </span>
                <span>
                  {clientList.find(client => client.id === showStorage?.id)?.alias || t('未命名')}(
                  {clientList.find(client => client.id === showStorage?.id)?.hostname})
                </span>
              </div>
              <div className="ip-address">
                <span className="title" style={{ color: '#86909C' }}>
                  {t('安全域：')}
                </span>
                <span>
                  {
                    agentareaList.find(
                      area =>
                        area.id ===
                        clientList.find(client => client.id === showStorage?.id)?.area_id,
                    )?.name
                  }
                </span>
              </div>
              <div className="ip-address">
                <span className="title" style={{ color: '#86909C' }}>
                  {t('操作系统：')}
                </span>
                <span>{clientList.find(client => client.id === showStorage?.id)?.os_system}</span>
              </div>
              <div className="ip-address">
                <span className="title" style={{ color: '#86909C' }}>
                  {t('版本号：')}
                </span>
                <span>
                  {clientList.find(client => client.id === showStorage?.id)?.agent_version}
                </span>
              </div>
              <div className="ip-address">
                <span className="title" style={{ color: '#86909C' }}>
                  {t('host_id：')}
                </span>
                <span>{clientList.find(client => client.id === showStorage?.id)?.host_id}</span>
              </div>
              <div className="ip-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                <span className="title" style={{ color: '#86909C' }}>
                  {t('本机IP地址：')}
                </span>
                <div style={{ display: 'flex', flexWrap: 'wrap', flex: 1 }}>
                  {clientList
                    .find(client => client.id === showStorage?.id)
                    ?.ip_addrs?.map(item => (
                      <div
                        key={item}
                        style={{
                          display: 'flex',
                          marginBottom: 6,
                          marginRight: 15,
                          flexDirection: 'row-reverse',
                        }}
                      >
                        <Typography.Paragraph
                          style={{ marginRight: 6, marginBottom: 0 }}
                          copyable={{
                            text: item,
                            icon: [
                              <IconFont key={1} type="icon-fuzhi" style={{ color: '#666' }} />,
                            ],
                          }}
                        />
                        {item}
                      </div>
                    )) || '-'}
                </div>
              </div>
              {Object.keys(clientList.find(client => client.id === showStorage?.id)?.memory_usage)
                ?.length > 0 && (
                <>
                  <div
                    style={{
                      color: '#333333',
                      fontSize: '14px',
                      fontWeight: 600,
                      marginBottom: '20px',
                      marginTop: '20px',
                    }}
                  >
                    {t('运行信息')}
                  </div>
                  <div className="mac-address">
                    <span className="title" style={{ color: '#86909C' }}>
                      {t('MAC地址：')}
                    </span>
                    <span>
                      {clientList
                        .find(client => client.id === showStorage.id)
                        ?.mac_addrs?.toString()
                        .replace(/,/g, '，')}
                    </span>
                  </div>
                  <div className="cpu">
                    <span className="title" style={{ color: '#86909C' }}>
                      {t('当前占用CPU：')}
                    </span>
                    <span>
                      {clientList.find(client => client.id === showStorage.id)?.cpu_percent / 100}%
                    </span>
                  </div>
                  <div className="distribution-result">
                    <div className="total-space">
                      <span>{t('总空间：')}</span>
                      <span>
                        {(
                          clientList.find(client => client.id === showStorage.id)?.memory_usage
                            ?.total /
                          1024 /
                          1024 /
                          1024
                        ).toFixed(2)}
                        G
                      </span>
                    </div>
                    <div className="used-space">
                      <span>{t('已用空间：')}</span>
                      <span>
                        {(
                          clientList.find(client => client.id === showStorage.id)?.memory_usage
                            ?.used /
                          1024 /
                          1024 /
                          1024
                        ).toFixed(2)}
                        G
                      </span>
                    </div>
                    <div className="free-space">
                      <span>{t('剩余空间：')}</span>
                      <span>
                        {(
                          (clientList.find(client => client.id === showStorage.id)?.memory_usage
                            ?.total -
                            clientList.find(client => client.id === showStorage.id)?.memory_usage
                              ?.used) /
                          1024 /
                          1024 /
                          1024
                        ).toFixed(2)}
                        G
                      </span>
                    </div>
                  </div>
                  <ReactECharts option={option()} />
                  {clientList.find(client => client.id === showStorage.id)?.disk_usage?.length >
                    0 && (
                    <div className="disk-usage">
                      <span className="title" style={{ color: '#86909C' }}>
                        {t('磁盘使用情况：')}
                      </span>
                    </div>
                  )}
                  {clientList
                    .find(client => client.id === showStorage.id)
                    ?.disk_usage?.map((item, index) => (
                      <>
                        <div className="disk-usage-item" style={{ marginBottom: '12px' }}>
                          <span style={{ color: '#86909C' }}>{t('磁盘名称：')}</span>
                          <span className="title" style={{ color: '#86909C' }}>
                            {item?.mountpoint}
                          </span>
                        </div>
                        <div className="distribution-result">
                          <div className="total-space">
                            <span>{t('总空间：')}</span>
                            <span>{(item?.total / 1024 / 1024 / 1024).toFixed(2)}G</span>
                          </div>
                          <div className="used-space">
                            <span>{t('已用空间：')}</span>
                            <span>{(item?.used / 1024 / 1024 / 1024).toFixed(2)}G</span>
                          </div>
                          <div className="free-space">
                            <span>{t('剩余空间：')}</span>
                            <span>
                              {((item?.total - item?.used) / 1024 / 1024 / 1024).toFixed(2)}G
                            </span>
                          </div>
                        </div>
                        <ReactECharts option={diskOption(item)} />
                      </>
                    ))}
                </>
              )}
            </div>
          )}
        </StorageModal>
        <DeleteModal
          text={t('关闭此功能可能会导致客户端无法正常使用，是否继续?')}
          visible={autoUpgrade.visible}
          confirmLoading={clientLoading}
          onOk={() => {
            setSwitchItem(
              (switchItem = {
                auto: false,
                id: autoUpgrade.id,
                remark: autoUpgrade.remark ? autoUpgrade.remark : '',
                areaId: autoUpgrade.areaId || 0,
                bizId: autoUpgrade?.bizId || 0,
              }),
            )
            setAutoUpgrade({
              visible: false,
              id: null,
              remark: null,
              areaId: null,
              bizId: null,
            })
          }}
          onCancel={() =>
            setAutoUpgrade({
              visible: false,
              id: null,
              remark: null,
              areaId: null,
              bizId: null,
            })
          }
        />
        <DeleteModal
          text={t('此客户端将永久删除，是否继续?')}
          visible={deleteMode.visible}
          onOk={async () => {
            try {
              if (deleteMode.id) {
                await deleteClient({ id: deleteMode.id })
                await getAgentList()
              }
            } catch (error) {}
            setDeleteMode({
              visible: false,
              id: null,
            })
          }}
          onCancel={() =>
            setDeleteMode({
              visible: false,
              id: null,
            })
          }
        />
        <DeleteModal
          text={t('此客户端将永久卸载，是否继续?')}
          visible={uninstallMode.visible}
          onOk={async () => {
            try {
              if (uninstallMode.id) {
                await uninstallClient({ id: uninstallMode.id })
                await getAgentList()
              }
            } catch (error) {}
            setUninstallMode({
              visible: false,
              id: null,
            })
          }}
          onCancel={() =>
            setUninstallMode({
              visible: false,
              id: null,
            })
          }
        />
        <DeleteModal
          text={t(
            `已选客户端将永久${showBatch.type === 'delete' ? t('删除') : t('卸载')}，是否继续?`,
          )}
          centered
          open={showBatch.visible}
          onOk={() => {
            if (showBatch.type === 'delete') {
              batchDeleteClient({ ids: selected })
                .then(() => {
                  Message.success(t('删除成功'))
                  selected.forEach(item => {
                    unSelect(item)
                  })
                  getAgentList()
                    .then()
                    .catch(_ => {})
                  setShowBatch({ visible: false, type: '' })
                })
                .catch(_ => {})
            } else {
              batchUnloadClient({ ids: selectedUnload })
                .then(() => {
                  Message.success(t('卸载成功'))
                  selectedUnload.forEach(item => {
                    unSelectUnload(item)
                  })
                  getAgentList()
                    .then()
                    .catch(_ => {})
                  setShowBatch({ visible: false, type: '' })
                })
                .catch(_ => {})
            }
          }}
          onCancel={() => setShowBatch({ visible: false, type: '' })}
        />
        <Modal
          width={670}
          title={<SignTitle show>{showClientHash?.clientName}</SignTitle>}
          centered
          visible={showClientHash.visible}
          onCancel={() => {
            setShowClientHash({ visible: false, clientName: '' })
          }}
          footer={null}
        >
          <TitleMessage>
            <IconTitle type={'icon-tixingshixin'} />
            <div>{t('注意：为了软件正常运行，请在杀毒软件/EDR等终端保护设施添加例外白名单')}</div>
          </TitleMessage>
          <Title>{t('客户端哈希值')}</Title>
          <div style={{ marginBottom: '16px' }}>
            {showClientHash?.hashArr?.map(hash => (
              <HashItem key={hash.id}>
                <div className="title">
                  {hash.file_type === 1 && <IconFont type="icon-exe" className="icon" />}
                  {hash.file_type === 2 && <IconFont type="icon-msi" className="icon" />}
                  {hash.file_type === 3 && <IconFont type="icon-dll" className="icon" />}
                  <div>{hash.name}</div>
                </div>
                {Object.keys(hash?.hash).map((key, index) => {
                  const arr = ['id', 'file_type', 'name', 'type']
                  if (arr.includes(key)) return null
                  return (
                    <div className="text" style={{ display: 'flex' }} key={hash.id + index}>
                      <div
                        style={{
                          width: '80px',
                          textAlign: 'left',
                          display: 'inline-block',
                          textIndent: '-1em',
                          paddingLeft: '1em',
                        }}
                      >
                        {key.includes('SHA')
                          ? key.toUpperCase().split('SHA').join('SHA-')
                          : key.toUpperCase()}
                        ：
                      </div>
                      <div style={{ flex: 1 }}>
                        <Typography.Text
                          copyable={{
                            icon: [<IconFont className="icon" key={1} type="icon-fuzhi" />],
                            text: hash?.hash[key],
                          }}
                        >
                          {hash?.hash[key]}
                        </Typography.Text>
                      </div>
                    </div>
                  )
                })}
              </HashItem>
            ))}
          </div>
        </Modal>
        <LogDownload showLog={showLog} setShowLog={setShowLog} updateClient={updateClient} />
        <EnvManagement
          open={showEnvManagement.visible}
          agentId={showEnvManagement.id}
          clientStatus={showEnvManagement.clientStatus}
          onClose={() => setShowEnvManagement({ visible: false, id: '', clientStatus: 0 })}
        />
      </div>
    </div>
  )
}

const Title = styled.div`
  width: 100%;
  height: 32px;
  margin: 0px 0 -2px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
`
const HashItem = styled.div`
  background-color: #f7f7f7;
  padding-left: 12px;
  padding-top: 10px;
  padding-bottom: 2px;
  margin-bottom: 10px;
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .icon {
      display: inline-block;
      margin-right: 8px;
    }
  }
  .text {
    color: #666666;
    margin-bottom: 10px;
    word-break: break-all;
    .icon {
      color: #666666;
    }
  }
`
const IconTitle = styled(IconFont)`
  color: #faad14;
  font-size: 18px;
  margin-right: 12px;
  transform: translateY(2px);
`
const TitleMessage = styled.div`
  width: 100%;
  height: 32px;
  background-color: #fff3e1;
  margin: -7px 0 17px 0;
  border: 1px solid #ffad31;
  border-radius: 4px;
  display: flex;
  justify-content: left;
  align-items: center;
  color: #ffb342;
  padding-left: 14px;
`

const ListItem = styled(Row)`
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  margin-bottom: 20px;
  padding: 15px;
  color: #666666;
  border-radius: 8px;
  .col {
    display: flex;
    .hash {
      :hover {
        text-decoration: underline;
      }
    }

    .storage-space {
      cursor: pointer;

      &:hover {
        color: #4238c9;
      }
    }
  }
  .flex {
    display: flex;
  }
  .succeed {
    margin-right: 5px;
    min-width: 14px;
    min-height: 14px;
    border-radius: 50%;
    background: #e1f3d8;
    position: relative;
    &::before {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #7ec050;
      margin-right: 16px;
      position: absolute;
      left: 3px;
      top: 3px;
    }
  }
  .error {
    margin-right: 5px;
    min-width: 14px;
    min-height: 14px;
    border-radius: 50%;
    background: #e6e7e8;
    position: relative;
    &::before {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #999999;
      margin-right: 16px;
      position: absolute;
      left: 3px;
      top: 3px;
    }
  }
  .title {
    color: #666;
  }
  .text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .ant-col-4 .ant-input-suffix {
    position: absolute;
    left: 164px;
    top: 8px;
    width: 32px;
  }
  .ant-col-4 .ant-tooltip {
    max-width: 280px;
    word-break: break-all;
  }

  .ant-input-affix-wrapper {
    width: 165px;
  }
  .ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow
    .ant-select-selection-item {
    padding-right: 14px;
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding: 0 8px;
  }
  .breathe {
    animation-name: light;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    color: #333;
  }
  @keyframes light {
    from {
      color: #333;
    }
    to {
      color: red;
    }
  }
`
const MenuItem = styled(Menu.Item)`
  margin: 0 2px;
  &:hover {
    background-color: #e7e9f3;
    border-radius: 4px;
  }
`
const StorageModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    position: relative;

    .ant-modal-close {
      width: 36px;
      height: 36px;
      background: #d8d6f4;
      box-shadow: -1px 4px 10px 0px #c7c7c7;
      border-radius: 6px;
      border: none;
      color: #4238c9;
      font-size: 16px;
      font-weight: 500;
      position: absolute;
      right: -8px;
      top: -8px;
      transition: transform 0.3s ease;

      &:hover {
        transform: translate(-18px, 18px);
        box-shadow: 0 0 0 0;
      }

      .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 36px;
        text-align: center;
      }
    }

    .ant-modal-header {
      height: 56px;
      background: #f2f0ff;
      border-bottom: none;
      margin: 0;
      padding: 19px 20px;
    }

    .ant-modal-body {
      padding: 24px;
    }
  }

  .content {
    /* width: 600px; */
    display: flex;
    flex-direction: column;

    .ip-address {
      margin-bottom: 24px;
    }

    .mac-address {
      margin-bottom: 24px;
    }
    .title {
      width: 120px;
      display: inline-block;
    }

    .cpu {
      margin-bottom: 24px;
    }

    .distribution-situation {
      font-weight: 500;
      margin-bottom: 24px;
    }

    .distribution-result {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
`
